import React from 'react';
import styled from '@emotion/styled';
import Image from 'next/image';
import ModalBase from '../../../../common/modal/ModalBase';
import Title from '../../../../common/text/Title';
import useDevice from '../../../../../hooks/common/useDevice';
import Span from '../../../../common/text/Span';
import useSwitching from '../../../../../hooks/common/useSwitching';
import CashbackConfirmModal from './CashbackConfirmModal';

const Base = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 90vw;
  max-width: 900px;
  overflow-y: overlay;
  max-height: 75vh;

  & > img {
    height: 670px !important;
    position: relative !important;
  }

  @media (max-width: 768px) {
    width: 70vw;
    max-width: 430px;
  }
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  width: 240px;
  height: 50px;
  border-radius: 5px;
  border: 0;
  background-color: #ffde02;
  padding: 0 20px;

  & > span {
    flex-grow: 1;
  }

  @media (max-width: 768px) {
    width: 200px;

    & > span {
      font-size: 15px;
    }
  }
`;

interface Props {
  closeEvent: () => void;
}

/**
 *  일시불캐시백 모달 컴포넌트
 * @param {function} closeEvent 닫기 함수
 *  */
function CashbackModal({ closeEvent }: Props): JSX.Element {
  // device
  const device: string = useDevice();
  const src: string = `/newcar/api/get/newOtherFinancialCashbackImg${
    device === 'mobile' ? 'Mobile' : ''
  }`;

  // switching
  const [confirmModal, switchingConfirm] = useSwitching(false);

  // function
  const onClick = (): void => {
    // closeEvent();
  };
  return (
    <>
      <ModalBase active={true} closeEvent={closeEvent}>
        <Title text='일시불 캐시백' />
        <Base>
          <ImageWrapper>
            <Image src={src} alt='일시불 캐시백 테이블 이미지' sizes='auto' fill />
          </ImageWrapper>
          <Button onClick={() => switchingConfirm()}>
            <Image
              src='/assets/images/cashbackImg.png'
              alt='캐시백 아이콘 이미지'
              width={30}
              height={30}
            />
            <Span fontSize='20px' fontWeight='500'>
              일시불 캐시백 신청
            </Span>
          </Button>
        </Base>
      </ModalBase>
      {confirmModal && <CashbackConfirmModal closeEvent={() => switchingConfirm()} />}
    </>
  );
}

export default CashbackModal;
